import { NumericStepperProps } from './NumericStepperProps';
import { TypeProduct } from './TypeProduct';
import { CartItemLabel } from './CartItemLabel';

export interface CartItemProps
  extends TypeProduct,
    Omit<NumericStepperProps, 'id' | 'style'> {
  labels?: CartItemLabel[];
  activeLabel?: CartItemLabel;
  calculatingState?: string;
  warning?: string;
  stockAvailable: boolean;
  singleItemDescriptor: string;
  pluralItemDescriptor: string;
  selectedOptions: { name: string | null; productId: number | null }[];
  onToggleOption: (
    option: { name: string | null; optionProductId: number | null },
    isSelected: boolean,
  ) => void;
  removeFromCart: () => void;
}

export enum CartActionOption {
  ShowNotifications = 'ShowNotifications',
  ShowCart = 'ShowCart',
}
